var swiper;
var modal = {
  $trigger: $(".js__modal-trigger"),
  $content: $(".c-modal"),
  $inner: $(".c-modal__inner"),
  $close: $(".js__modal-close"),
  $overlay: $(".c-modal__overlay"),
  $control: $(".swiper-button-next, .swiper-button-prev"),
  target: 0,
  height: 0,
  position: 0,

  type: "",
  init: function () {
    setTimeout(function () {
      TweenMax.set(modal.$content, { display: "none" });
      TweenMax.set(modal.$overlay, { display: "block" });
      TweenMax.set(modal.$control, { display: "block" });
    }, 100);

    modal.$trigger.on("click", function () {
      modal.target = $(this).data("index");
      modal.open($(".js__modal-trigger").index(this));
      return false;
    });
    modal.$close.on("click", function () {
      modal.close();
    });
  },
  open: function (index) {
    if ($(".c-modal.sustainability")[0]) {
      TweenMax.set(".c-modal__target", { display: "none" });
      TweenMax.set($(".c-modal__target").eq(index), { display: "block" });
      TweenMax.set(modal.$inner, {
        y: "50px",
      });
    } else {
      TweenMax.set(modal.$inner, {
        x: "-30px",
      });
    }
    if (modal.target !== undefined) {
      swiper.slideTo(modal.target);
    }
    TweenMax.to(modal.$content, 0.18, {
      display: "block",
      opacity: 1,
      ease: Circ.easeOut,
      onComplete: function () {
        $(window).trigger("modalOpen");
        modal.height = $(modal.target).find(".c-modal__inner").outerHeight();
        if ($(".c-modal.sustainability")) {
          modal.position = $(document).scrollTop() + 100;
        } else if ($(window).width() <= 750) {
          modal.position = $(document).scrollTop() + 70;
        } else {
          modal.position =
            $(document).scrollTop() +
            [$(window).height() - modal.$inner.height()] / 2;
        }
        TweenMax.set(modal.$inner, { top: modal.position });
        TweenMax.set($(".c-modal__target"), { opacity: 1 });
        TweenMax.to(modal.$inner, 0.48, {
          opacity: 1,
          x: "0px",
          y: "0px",
          ease: Power2.easeOut,
        });
      },
    });
  },
  close: function () {
    TweenMax.to(modal.$inner, 0.48, {
      opacity: 0,
      y: $(".c-modal.sustainability")[0] ? "50px" : "0px",
      x: $(".c-modal.sustainability")[0] ? "0px" : "-30px",
      ease: Power2.easeOut,
      onComplete: function () {
        TweenMax.to(modal.$content, 0.18, {
          display: "none",
          opacity: 0,
          ease: Power2.easeOut,
        });
        TweenMax.set($(".c-modal__target"), { opacity: 0 });
      },
    });
  },
};

$(window).on("load", function () {
  if ($(".c-modal")[0]) {
    modal.init();
  }
  if ($(".swiper-container")[0]) {
    swiper = new Swiper(".swiper-container", {
      autoHeight: true, //enable auto height
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
});
